import {
  faArrowUpRight,
  faCircleInfo,
} from "@fortawesome/pro-regular-svg-icons";

import { useFlow } from "src/api/queries";
import { buildDecisionTraceUrl } from "src/cases/caseView/hooks/buildDecisionTraceUrl";
import { Icon } from "src/design-system/Icon";
import { Tooltip } from "src/design-system/Tooltip";
import { useCapabilities } from "src/hooks/useCapabilities";
import { CasePageParams } from "src/router/urls";
import { useParamsDecode } from "src/utils/useParamsDecode";

type DecisionTraceButtonProps = {
  decisionId?: string | null;
  flowId?: string | null;
  versionId?: string | null;
  // Case environment, used to target the right decision environment.
  env?: string;
  dataLoc?: string;
};

export const DecisionTraceButton: React.FC<DecisionTraceButtonProps> = ({
  decisionId,
  flowId,
  versionId,
  env,
  dataLoc = "decision-trace",
}) => {
  const { orgId, wsId } = useParamsDecode<CasePageParams>();
  const {
    cases: { canViewDecisionTrace },
  } = useCapabilities();

  const url = buildDecisionTraceUrl({
    orgId,
    wsId,
    flowId,
    versionId,
    decisionId,
    env,
  });

  const { data: flow } = useFlow(
    url && canViewDecisionTrace ? (flowId ?? undefined) : undefined,
  );

  if (!url || !canViewDecisionTrace) {
    return null;
  }

  const versionName = flow?.versions.find(
    (version) => version.id === versionId,
  )?.name;
  const label = [flow?.name, versionName].filter(Boolean).join(", ");

  return (
    <Tooltip
      dataLoc={dataLoc}
      delay={250}
      headerAction={{
        icon: faArrowUpRight,
        onClick: () => window.open(url, "_blank", "noopener,noreferrer"),
      }}
      placement="top"
      title={label || "View decision"}
    >
      <Icon dataLoc={`${dataLoc}-icon`} icon={faCircleInfo} size="xs" />
    </Tooltip>
  );
};
